import { render } from "./CreateCollectionBtn.vue?vue&type=template&id=2344152f"
import script from "./CreateCollectionBtn.vue?vue&type=script&lang=js"
export * from "./CreateCollectionBtn.vue?vue&type=script&lang=js"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__